var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.875V8.5H6.625V9.125H6H5.375V9.75H4.75H4.125V10.375H3.5H2.875V11H2.25H1.625H1V10.375V9.75H1.625V9.125V8.5H2.25V7.875V7.25H2.875V6.625V6H2.25V5.375H1.625V4.75H1V4.125V3.5H1.625H2.25H2.875H3.5H4.125V2.875H4.75V2.25V1.625H5.375V1H6H6.625V1.625H6V2.25V2.875V3.5V4.125V4.75V5.375V6V6.625V7.25V7.875ZM7.25 2.875H6.625V2.25V1.625H7.25V2.25V2.875ZM10.375 4.75V4.125H9.75H9.125H8.5H7.875H7.25V3.5V2.875H7.875V3.5H8.5H9.125H9.75H10.375H11V4.125V4.75H10.375ZM9.75 5.375V4.75H10.375V5.375H9.75ZM9.125 6V5.375H9.75V6H9.125ZM9.125 7.25H8.5V6.625V6H9.125V6.625V7.25ZM9.75 8.5H9.125V7.875V7.25H9.75V7.875V8.5ZM10.375 9.75H9.75V9.125V8.5H10.375V9.125V9.75ZM9.125 10.375H9.75H10.375V9.75H11V10.375V11H10.375H9.75H9.125V10.375ZM7.875 9.75H7.25H6.625V9.125H7.25H7.875V9.75ZM7.875 9.75V10.375H8.5H9.125V9.75H8.5H7.875Z",
    fill: "#FFBD3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarS);
export default __webpack_public_path__ + "static/media/star-s.87f0a3f80e12b94a7f37a3ac19453dcc.svg";
export { ForwardRef as ReactComponent };